import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/building.js";
import "@ui5/webcomponents-icons/dist/home.js";
import "@ui5/webcomponents-icons/dist/document-text.js";
import "@ui5/webcomponents-icons/dist/line-chart.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { leasePermissions, leaseSettingsGroup } from "./permissions";

/** Leasing entries of the navigation registry (group `lease`, docs/contracts/leasing.md). */
export const leaseNavigation: readonly NavigationEntry[] = [
  {
    key: "lease.leases",
    labelKey: "nav.leaseLeases",
    icon: "document-text",
    path: "/lease/leases",
    permission: leasePermissions.contractView,
  },
  {
    key: "lease.properties",
    labelKey: "nav.leaseProperties",
    icon: "building",
    path: "/lease/properties",
    permission: leasePermissions.propertyView,
  },
  {
    key: "lease.units",
    labelKey: "nav.leaseUnits",
    icon: "home",
    path: "/lease/units",
    permission: leasePermissions.unitView,
  },
  {
    key: "lease.straightLine",
    labelKey: "nav.leaseStraightLine",
    icon: "line-chart",
    path: "/lease/straight-line",
    permission: leasePermissions.straightLineView,
  },
  {
    key: "lease.reports",
    labelKey: "nav.leaseReports",
    icon: "business-objects-experience",
    path: "/lease/reports",
    permission: leasePermissions.reportView,
  },
  {
    key: "lease.settings",
    labelKey: "nav.leaseSettings",
    icon: "settings",
    path: `/platform/settings/${leaseSettingsGroup}`,
    permission: leasePermissions.settingsView,
  },
];
